import {
  Component,
  ViewChild,
  TemplateRef,
  Input,
  Output,
  EventEmitter,
  Inject,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { ComparativeAnalysisService } from "../comparative-analysis.service";
import {
  createRevSurTabUserSettings,
  getMetaPayloadFromUrls,
  updateCustomTableSettings,
  updateCustomTableSettingsForTickers,
} from "src/app/comparative-analysis/comparative-analysis-utils";
import { TAB_BE_MAPPING, USER_SETTINGS_LINE_ID } from "../constants";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { ComparativeTickerModalComponent } from "../comparative-ticker-modal/comparative-ticker-modal.component";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { WatchlistService } from "src/app/watchlist/watchlist.service";
import { AddWatchlistData } from "src/app/store/actions/global.actions";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { CustomSkeletonConfig } from "src/app/shared/custom-skeleton/custom-skeleton-model";
import {
  createRevSupComparisonGridData,
  updateRevSupComparisonGridData,
} from "src/app/utils/comparison-grid";
import { PAGE_NAME } from "src/app/common-constants";
import { getTickersChunksForDataCall } from "src/app/utils/common";
import { Subscription, Observable, from, timer } from "rxjs";
import { mergeMap } from "rxjs/operators";
import {
  SetDpParams,
  DeleteDpParams,
} from "src/app/store/actions/global-subheader.actions";
import {
  VAIconRegistryService,
  check,
  close,
  closeCircle,
  fileExcel,
  infoCircle,
  chevronDown,
  chevronUp,
} from "@va/core-library/icons";
import { faSpinner } from "@fortawesome/pro-light-svg-icons";
import {
  faTimes,
  faCheck,
  faTimesCircle,
  faInfoCircle,
  faTable as fasTable,
  faFileExcel as fasFileExcel,
  faChartLine as fasChartLine,
  faArrowToBottom as fasArrowToBottom,
} from "@fortawesome/pro-solid-svg-icons";
import { CompsDataService } from "src/app/comps-page/comps-data.service";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-comparative-revi-sur",
  templateUrl: "./comparative-revi-sur.component.html",
  styleUrls: ["./comparative-revi-sur.component.scss"],
})
export class ComparativeReviSurComponent {
  @Input() isActive = true;
  @Input() tabType = TAB_BE_MAPPING.revision;
  @Input() state;
  @Input() shouldFetchData = false;
  @Output() updateRevSupState: EventEmitter<any> = new EventEmitter();
  @Output() onDataFetchInitiate: EventEmitter<any> = new EventEmitter();
  @Input() routeParams;
  @Input() routeQueryParams;
  @Input() pageType;
  @Input() compType;
  @Input() compId;
  @Input() recentlyVisitedCompanies;
  @Input() watchlistData;
  @Input() industryMenuData;
  @Input() suggestedPeers;
  @Input() tickerModalDataReady;
  @Input() marketGeoData;
  @Output() onFetchLineitemData: EventEmitter<any> = new EventEmitter();
  @Output() initiateWatchlistFetch: EventEmitter<any> = new EventEmitter();
  @Output() updateUnsavedDataStatus: EventEmitter<any> = new EventEmitter();
  sortedTickers = [];
  headerTitle;
  tickers = [];
  currency = "";
  suggestedLineItems = [];
  lineItem = undefined;
  selectedLineItemId;
  analyticsGrowthType = [
    "last_reported_interim_preq", //Revision analysis
    "last_reported_interim_current", //Revision analysis
    "upcoming_interim", //Surprise analysis
  ];
  noFormulaCols = [
    "3yr_fwd_cagr_before", //Revision analysis
    "3yr_fwd_cagr_after", //Revision analysis
    "quarter_average_surprise", //Surprise analysis
  ];
  sourceVaActuals = ["last_reported_interim_current"];
  suggestedLineItemMenuName = "Suggested Line Items";
  lineItemsData;
  isStdLineItemsUpdateInProgress = false;

  industryId: number;
  gridData: any;
  magnitudeMessage;
  skeletonDefaultConfig: CustomSkeletonConfig = {
    skeletonType: "default",
  };
  revisionInititalSortColumnKey = "last_earnings_date";
  surpriseInititalSortColumnKey = "next_earnings_date";
  previousReloadAllStoreValue = false;
  marketCap = [-1];
  region = [-1];
  countries;
  subGroup = -1;
  showBlankRows = false;
  showBlankRowsLabel = "Show Blank Rows";
  selectedCell = "";
  selectedRow = "";
  shouldFetchMeta;
  pageShortName;
  exportOptVisible = false;
  tickerLimit = 500;
  tickersModal: NzModalRef;
  storeDataKey = "watchlist";
  pageNameData = PAGE_NAME;
  apiEP: string = window.apiUrl;
  assets = environment.assetUrl;

  //icons
  faTimes = faTimes;
  faCheck = faCheck;
  faTimesCircle = faTimesCircle;
  faInfoCircle = faInfoCircle;
  faSpinner = faSpinner;
  fasTable = fasTable;
  fasChartLine = fasChartLine;
  fasFileExcel = fasFileExcel;
  fasArrowToBottom = fasArrowToBottom;

  //loader
  isMetaInProgress = true;
  isDataInProgress = false;
  isUserSettingUpdateInProgress = false;
  loadingDocuments = false;

  //snackbar
  snackbarInfo: { message: string; type: string } = {
    message: "",
    type: "info",
  };
  snackBarRef: MatSnackBarRef<any>;
  snackbarMessage = "";

  //subscribers
  routeParamSubscriber: Subscription;
  globalAppSettingSubscriber: Subscription;
  dataSubscriber: Subscription;
  dataSubscriberFirstBatch: Subscription;
  dataSubscriberSecondBatch: Subscription;
  metaSubscriber: Subscription;
  currencyMessageSubscriber: Subscription;
  lineItemsSubscriber: Subscription;

  constructor(
    private dataService: ComparativeAnalysisService,
    private store: Store<AppState>,
    private snackBar: MatSnackBar,
    public router: Router,
    private watchlistDataService: WatchlistService,
    private modalService: NzModalService,
    private iconRegistry: VAIconRegistryService,
    private compsDataService: CompsDataService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
  ) {
    this.iconRegistry.registerIcons([
      fileExcel,
      close,
      check,
      closeCircle,
      infoCircle,
      chevronDown,
      chevronUp,
    ]);
  }

  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  @ViewChild("failureTemplate") failureTemplate: TemplateRef<any>;
  @ViewChild("infoTemplate") infoTemplate: TemplateRef<any>;

  ngOnInit() {
    this.globalAppSettingSubscriber = this.store
      .select(
        stateGetter("globalHeader", "globalAppSettings", "period_settings"),
      )
      .subscribe((data) => {
        if (data) {
          //raise update of common state to trigger data calls on all tabs
          if (!this.isMetaInProgress && this.gridData && this.isActive) {
            this.createAndFetchCompTableData();
          }
        }
      });
  }

  /**
   * Unsubscribes from store when component is destroyed
   */
  ngOnDestroy(): void {
    if (this.routeParamSubscriber) {
      this.routeParamSubscriber.unsubscribe();
    }
    if (this.globalAppSettingSubscriber) {
      this.globalAppSettingSubscriber.unsubscribe();
    }
    this.dismissSnackBar();
  }

  ngOnChanges(changes) {
    if (changes.tabType) {
      this.pageShortName =
        this.tabType === TAB_BE_MAPPING.revision
          ? PAGE_NAME.industryRevision
          : PAGE_NAME.industrySurprise;
    }
    if (
      changes.state &&
      changes.state.currentValue &&
      changes.state.currentValue !== changes.state.previousValue
    ) {
      this.tickers = this.state.tickers;
      this.headerTitle = this.state.headerTitle;
      this.currency = this.state.currency;
    }

    if (
      (changes.routeParams &&
        changes.routeParams.currentValue &&
        changes.routeParams.currentValue !==
          changes.routeParams.previousValue) ||
      (changes.routeQueryParams &&
        changes.routeQueryParams.currentValue &&
        changes.routeQueryParams.currentValue !==
          changes.routeQueryParams.previousValue)
    ) {
      this.shouldFetchMeta = true;
    }

    if (
      changes.isActive &&
      changes.isActive.currentValue &&
      !changes.isActive.previousValue
    ) {
      if (this.shouldFetchMeta || changes.isActive.firstChange) {
        const isUserPageType = this.checkIfUserPageType();
        const metaPayload = isUserPageType
          ? getMetaPayloadFromUrls(
              this.routeParams,
              this.routeQueryParams,
              this.tabType,
              this.compType,
            )
          : getMetaPayloadFromUrls(
              this.routeParams,
              this.routeQueryParams,
              this.tabType,
              this.compType,
              this.state,
            );
        this.fetchAndUpdateComparativeMeta(metaPayload);
        this.shouldFetchMeta = false;
      } else if (
        this.shouldFetchData &&
        this.tickers &&
        this.tickers.length &&
        !changes.isActive.firstChange
      ) {
        this.createAndFetchCompTableData();
      }
    }
  }

  checkIfUserPageType() {
    return this.pageType === "user";
  }

  /**
   * It executes on industry change
   * Makes call to get Industry meta and updates the filters selection data according to it.
   * Makes call to get stdLines Info for the received tickers
   */
  fetchAndUpdateComparativeMeta(metaPayload) {
    this.shouldFetchMeta = false;
    this.isMetaInProgress = true;
    // reset filters on change of industry
    this.setDefaultFilters();

    if (this.metaSubscriber) {
      this.metaSubscriber.unsubscribe();
    }
    this.metaSubscriber = this.dataService
      .fetchComparativeAnalysisMeta(metaPayload)
      .subscribe(
        (response: { data: any; status: string; status_code?: number }) => {
          if (response.status === "success") {
            const responseData = response.data;
            this.headerTitle = responseData.comps_name;
            this.updateStateWithMeta(responseData);
            if (
              !responseData.selected_lines ||
              !responseData.selected_lines.length
            ) {
              this.snackbarInfo.message = "No data Available.";
              this.snackbarInfo.type = "info";
              this.showSnackBarToastMessage(this.snackbarInfo);
            } else {
              this.createAndFetchCompTableData();
              if (responseData.ticker_info && responseData.ticker_info.length) {
                // Update stdLineItem on Tickers change
                this.fetchAndUpdateStdLineItems(
                  response.data.ticker_info,
                  false,
                  this.currency,
                  this.suggestedLineItems,
                );
              }
            }
            this.isMetaInProgress = false;
          } else {
            console.error("Meta call failed");
          }
        },
      );
  }

  /**
   * store meta details to variables
   *  @param {obj} meta: meta details
   */
  updateStateWithMeta(meta) {
    this.tickers = meta.ticker_info ? meta.ticker_info : [];
    this.headerTitle = meta.comps_name;
    this.lineItem = meta.selected_lines[0];
    this.selectedLineItemId = [meta.selected_lines[0].uniquesliid];
    this.suggestedLineItems = meta.suggested_line_info;
    this.magnitudeMessage = meta.magnitude_message;
    this.showBlankRows = meta.show_blank_rows;
    this.currency = meta.currency;
    const state = {
      tickers: this.tickers,
      currency: this.currency,
      magnitudeMessage: this.magnitudeMessage,
      lineItem: this.lineItem,
      selectedLineItemId: this.selectedLineItemId,
      headerTitle: this.headerTitle,
    };

    this.updateRevSupState.emit(state);
  }

  /**
   * reset filters selection
   */
  setDefaultFilters() {
    // this.suggestedLineItems = [];
    // this.lineItemsData;
    // this.tickers = [];
    // this.lineItem = undefined;
    // this.showBlankRows = false;
    this.showBlankRowsLabel = "Show Blank Rows";
  }

  /**
   * Set the snackbar message and snackbarRef
   */
  showSnackBarToastMessage(info) {
    this.snackbarMessage = info.message;
    this.snackBarRef = this.getSnackbarRef(info.type);
  }

  /**
   * Hides the snack bar
   */
  dismissSnackBar() {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
    }
  }

  /**
   * Shows snackbar message, according to (success | info | failure) template
   * @param {object} type - type of message (success | info | failure)
   */
  getSnackbarRef(type) {
    const typeMap = {
      success: this.successTemplate,
      info: this.infoTemplate,
      failure: this.failureTemplate,
    };
    if (typeMap[type]) {
      return this.snackBar.openFromTemplate(typeMap[type], {
        panelClass: type,
        duration: 5000,
        verticalPosition: "top",
      });
    }
    return undefined;
  }

  fetchAndUpdateStdLineItems(
    tickers,
    showSuggestedLineItems,
    currency,
    suggestedLineItems,
  ) {
    if (!tickers || !tickers.length) {
      return;
    }
    const tickerIds = tickers.map((item) => item.ticker);

    this.isStdLineItemsUpdateInProgress = true;
    if (this.lineItemsSubscriber) {
      this.lineItemsSubscriber.unsubscribe();
    }
    this.lineItemsSubscriber = this.dataService
      .getStdLineItems(tickerIds, showSuggestedLineItems, currency, false)
      .subscribe((response) => {
        if (response.status === "success") {
          const stdData = response.data;
          const formattedStdLineItems = [];
          if (!showSuggestedLineItems && suggestedLineItems) {
            const suggestLineItems = {
              tab_full_name: this.suggestedLineItemMenuName,
              tab_short_name: "SL",
              tab_sli_data: suggestedLineItems,
            };
            formattedStdLineItems.push(suggestLineItems);
          }
          for (const item of stdData) {
            const formattedTabSliData = [];
            // format the tab_sli_data to match data shape of lineItems required for LineitemSearchComponent component
            for (const lineItem of item.tab_sli_data) {
              formattedTabSliData.push({
                ...lineItem,
                label: lineItem.name,
                sli_id_count: lineItem.sli_id_count,
                id: lineItem.uniquesliid,
                disabled: false,
                isLeaf: true,
                level: 2,
                header: false,
                isCollapsed: true,
              });
            }
            const currentItem = {
              tab_full_name: item.tab_full_name,
              tab_short_name: item.tab_short_name,
              tab_sli_data: formattedTabSliData,
            };
            formattedStdLineItems.push(currentItem);
          }
          this.lineItemsData = formattedStdLineItems;
        }
        this.isStdLineItemsUpdateInProgress = false;
      });
  }

  /**
   * It creates user tab settings object
   * @param {array} lineItem - array of lineitem id
   */
  createUserTabSettings(lineItem) {
    const formattedLineItem = lineItem
      ? [
          {
            uniquesliid: lineItem.uniquesliid || lineItem.sli_id,
          },
        ]
      : undefined;
    return {
      lineitem: formattedLineItem,
      industry_id: this.industryId,
      subindustry_id: [this.subGroup],
    };
  }

  /**
   * It creates grid data
   * It makes data call request and updates grid data according to it
   */
  createAndFetchCompTableData() {
    this.onDataFetchInitiate.emit();
    if (this.tickers && this.lineItem && this.pageShortName) {
      this.gridData = createRevSupComparisonGridData(
        this.tickers,
        this.lineItem,
        this.pageShortName,
      );
      this.fetchAndUpdateGridData(this.tickers, this.lineItem, this.currency);
    }
  }

  createDataCallObservables(tickers, lineItem, currency) {
    const result = [];
    let url = `uniquesliid=${lineItem.uniquesliid}`;
    url = `${url}&tab_name=${this.pageShortName}`;
    if (currency && currency !== "Base") {
      url += `&currency=${currency}`;
    }
    for (const item of tickers) {
      const dataUrl = `${url}&ticker=${item.ticker}`;
      result.push(dataUrl);
    }
    return result;
  }

  createDynamicDataCallObservables(
    tickers,
    lineItem,
    maxParallelCalls,
    currency,
  ) {
    const result = [];
    let url = `uniquesliid=${lineItem.uniquesliid}`;
    url = `${url}&tab_name=${this.pageShortName}`;
    if (currency && currency !== "Base") {
      url += `&currency=${currency}`;
    }
    const tickersChunks = getTickersChunksForDataCall(
      tickers,
      maxParallelCalls,
    );
    for (const item of tickersChunks) {
      let tickerParams = "";
      for (let i = 0; i < item.length; i++) {
        tickerParams = `${tickerParams}&ticker=${item[i].ticker}`;
      }
      const dataUrl = `${url}${tickerParams}`;
      result.push(dataUrl);
    }
    return result;
  }

  createDelayUsingTimer(delayValue: number) {
    return timer(delayValue);
  }

  /**
   * It makes data call request and updates grid data according to it
   */
  fetchAndUpdateGridData(tickerInfo, lineItem, currency) {
    if (this.dataSubscriberSecondBatch) {
      this.dataSubscriberSecondBatch.unsubscribe();
    }
    if (this.dataSubscriberFirstBatch) {
      this.dataSubscriberFirstBatch.unsubscribe();
    }
    if (this.dataSubscriber) {
      this.dataSubscriber.unsubscribe();
    }
    this.isDataInProgress = true;
    this.selectedCell = "";
    this.selectedRow = "";
    this.store.dispatch(new DeleteDpParams());
    let gridData = { ...this.gridData };

    const singleTickerCallCount = 20;
    const firstSetOfTicker = tickerInfo.slice(0, singleTickerCallCount);
    const remainingSetOfTickers = tickerInfo.slice(
      singleTickerCallCount,
      tickerInfo.length,
    );

    const firstBatchOfurls = this.createDataCallObservables(
      firstSetOfTicker,
      lineItem,
      currency,
    );
    let firstBatchSubscriptionIndex = 0;

    this.dataSubscriber = new Observable((observer) => {
      this.dataSubscriberFirstBatch = from(firstBatchOfurls)
        .pipe(
          mergeMap((item) => {
            return this.dataService.getIndustryTabData(item);
          }),
        )
        .subscribe((response: { data; status }) => {
          if (response.status === "success") {
            const data = response.data;
            gridData = updateRevSupComparisonGridData(
              gridData,
              data,
              lineItem,
              this.pageShortName,
            );
            this.gridData = gridData;
          } else {
            console.error("Error while fetching  data");
          }
          firstBatchSubscriptionIndex++;
          if (
            (!remainingSetOfTickers || !remainingSetOfTickers.length) &&
            firstBatchSubscriptionIndex === firstBatchOfurls.length
          ) {
            observer.next(gridData);
            observer.complete();
          }
        });

      if (remainingSetOfTickers && remainingSetOfTickers.length) {
        const maxParallelCallsForRemainingBatchOfTickers = 50;
        const nextBatchOfUrls = this.createDynamicDataCallObservables(
          remainingSetOfTickers,
          lineItem,
          maxParallelCallsForRemainingBatchOfTickers,
          currency,
        );
        let remainingBatchSubscriptionIndex = 0;
        this.createDelayUsingTimer(1000)
          .pipe()
          .subscribe(() => {
            this.dataSubscriberSecondBatch = from(nextBatchOfUrls)
              .pipe(
                mergeMap((item) => {
                  return this.dataService.getIndustryTabData(item);
                }),
              )
              .subscribe((response: { data; status }) => {
                remainingBatchSubscriptionIndex++;
                if (response.status === "success") {
                  const data = response.data;
                  gridData = updateRevSupComparisonGridData(
                    gridData,
                    data,
                    lineItem,
                    this.pageShortName,
                  );
                  this.gridData = gridData;
                } else {
                  console.error("Error while fetching data");
                }
                if (
                  remainingBatchSubscriptionIndex === nextBatchOfUrls.length
                ) {
                  observer.next(gridData);
                  observer.complete();
                }
              });
          });
      }
    }).subscribe((gridData: any) => {
      this.gridData = { ...gridData };
      const tickersWithoutData =
        tickerInfo.length - (this.gridData.tickerWithDataCount || 0);
      this.showBlankRowsLabel = `Show ${tickersWithoutData} Blank Rows`;
      this.isDataInProgress = false;
    });
  }

  updateFormattedLineItem(lineItem, lineitemId) {
    const sliId = [lineitemId];
    this.dataService
      .getLineItemDetails(
        sliId,
        this.industryId,
        this.currency,
        this.tickers[0].ticker,
      )
      .subscribe((response) => {
        if (response.status === "success" && response.data) {
          lineItem["formatted_name"] = response.data[lineItem.uniquesliid]
            ? response.data[lineItem.uniquesliid]["formatted_name"]
            : lineItem.name;
        }
        this.lineItem = { ...lineItem };
        this.selectedLineItemId = sliId;
        this.createAndFetchCompTableData();
        const dataToUpdate = {
          lineItem: lineItem,
          selectedLineItemId: sliId,
        };
        this.updateRevSupState.emit(dataToUpdate);
      });
  }

  /**
   * It stores the selected line item
   * It makes data call request and updates grid data
   * @param {obect} item - selected line item
   */
  updateLineItem(item) {
    const id = item.uniquesliid || item.sli_id;
    this.updateFormattedLineItem(item, id);
    this.snackbarInfo.message = `${item.label} Line Item selected.`;
    this.snackbarInfo.type = "success";
    this.showSnackBarToastMessage(this.snackbarInfo);
  }

  /**
   * Executes on the selection of lineitem
   * It checks if lineitem exists or not and shows toast message according to it.
   * It formats the line item, and removes unnecessary items
   * It updates the line item
   * @param {object} item - selected lineitem
   */
  handleLineItemSelection(item) {
    if (item) {
      const formatLineItem = { ...item, parent: undefined }; // remove the parent property from selected lineitem
      const isUserPageType = this.checkIfUserPageType();
      if (isUserPageType) {
        const lineIdProperty = USER_SETTINGS_LINE_ID[this.tabType];
        this.isUserSettingUpdateInProgress = true;
        const lineItemToUpdate = {
          LineItem: {
            [lineIdProperty]: [formatLineItem.uniquesliid],
          },
        };
        const settingsPayload = updateCustomTableSettings(
          this.compId,
          this.tabType,
          lineItemToUpdate,
        );
        this.dataService
          .updateCustomComps(settingsPayload)
          .subscribe((response) => {
            if (response.status === "success") {
              this.updateLineItem(formatLineItem);
            }
            this.isUserSettingUpdateInProgress = false;
          });
      } else {
        this.updateLineItem(formatLineItem);
        this.updateUnsavedDataStatus.emit();
      }
    }
  }

  updateTickerOrder(tickerOrderedList) {
    this.sortedTickers = tickerOrderedList;
  }
  /**
   * Executes on the click of export Values / Excel Add-In Formulas
   * According to export type it generated excel sheet
   * @param {number} exportType - type of export  0(Excel Add-In Formulas ) | 1(Values)
   */
  exportValue(exportType) {
    this.exportOptVisible = false;
    this.loadingDocuments = true;
    let templateType = "industry revision analysis";
    let tabName = "Revision";
    if (this.pageShortName === "surpriseanalysis") {
      templateType = "industry surprise analysis";
      tabName = "Surprise";
    }
    const tickerCids = this.sortedTickers.map((item) => {
      return item.companyid || item.company_id || item.cid;
    });
    const state = {
      tickers: this.tickers,
      currency: this.currency,
      selectedLineItemId: this.selectedLineItemId,
    };
    const revSupDetails = createRevSurTabUserSettings(
      state,
      tickerCids,
      tabName,
    );

    const payload = {
      ...revSupDetails,
      tab_type: tabName,
      comp_type: this.compType,
      comps_name: this.headerTitle,
    };

    this.dataService
      .downloadComparativeExport(payload, templateType, tabName, exportType)
      .subscribe(
        (res) => {
          if (res["status"] === "success") {
            const fileName = res["filename"];
            const trackerId = res["trackerid"];
            const downloadUrl = `/api/excel_file_download?exceltrackerid=${trackerId}`;
            const startIFrameTime = new Date().getTime();
            const iFrameToLoad = this._document.createElement("iframe");
            const body = this._document.getElementsByTagName("body")[0];
            iFrameToLoad.id = `${fileName}`;
            iFrameToLoad.name = `${fileName}`;
            iFrameToLoad.src = downloadUrl;
            iFrameToLoad.setAttribute(
              "style",
              "visibility:hidden;display:none",
            );
            body.appendChild(iFrameToLoad);

            const checkInterval = setInterval(() => {
              const iFrameToGet = this._document.getElementById(
                `${fileName}`,
              ) as HTMLIFrameElement;
              const iFrame =
                iFrameToGet.contentDocument ||
                iFrameToGet.contentWindow.document;
              /*
              This check will run till the iFrame either doesn't load or for a max of 30secs
              Or till the ready state of the iFrame doesn't evaluate
            */
              if (
                iFrame.readyState === "complete" ||
                iFrame.readyState === "interactive" ||
                new Date().getTime() - startIFrameTime > 30000
              ) {
                //Commenting for now
                // this._document
                //   .getElementById(`research_download_${dataToPass.id}`)
                //   .remove();
                clearInterval(checkInterval);
                return;
              }
            }, 2000);
            this.loadingDocuments = false;
            // iframe.onload = () => {
            //   setTimeout(function() {
            //     document.getElementById(`research_download_${dataToPass.id}`).remove();
            //   }, 100);
            //   this.loading = false;
            // };
          } else {
            this.loadingDocuments = false;
            this.snackbarInfo.message =
              "Industry export couldn't be downloaded.";
            this.snackbarInfo.type = "failure";
            this.showSnackBarToastMessage(this.snackbarInfo);
          }
        },
        (err) => {
          this.loadingDocuments = false;
          console.error(err);
        },
      );
  }

  /**
   * It filters the compTableData on the basis of remove blanks switch value
   * If it is true it filters the tickers which have data for all periods
   * @param {boolean} value - selected value of remove show blank rows
   */
  handleShowBlanksSwitchChange(value) {
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const showBlankToUpdate = {
        ShowBlank: {
          show_blank: value,
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        this.tabType,
        showBlankToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.updateRevSupState.emit({
              showBlankRows: value,
            });
            this.showBlankRows = value;
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.updateRevSupState.emit({
        showBlankRows: value,
      });
      this.showBlankRows = value;
      this.updateUnsavedDataStatus.emit();
    }
  }

  /**
   * @param {string} ticker
   * @param {int} parentId
   * @param {string} columnId
   * @param {boolean} hasFB
   */
  createDpParam(paramData) {
    const { ticker, columnId, parentId, hasFB } = paramData;
    this.selectedRow = ticker;
    const gridDataRowObj = {};
    for (const item of this.gridData.rowData) {
      gridDataRowObj[item["ticker"]] = item;
    }
    const sliCompsData = gridDataRowObj[ticker][parentId];
    const period =
      gridDataRowObj[ticker]["p_m"] && gridDataRowObj[ticker]["p_m"][columnId];
    if (
      !this.noFormulaCols.includes(columnId) &&
      sliCompsData &&
      sliCompsData[columnId] &&
      sliCompsData[columnId]["raw"] !== undefined &&
      sliCompsData[columnId]["raw"] !== null
    ) {
      //process dpParam call only if its a new data cell selection
      if (
        hasFB &&
        this.selectedCell !== `${ticker}_${columnId}_${parentId || ""}`
      ) {
        const today = new Date();
        const mm = today.getMonth() + 1;
        const dd = today.getDate();
        const yyyy = today.getFullYear();
        const date =
          columnId === "last_reported_interim_preq"
            ? gridDataRowObj[ticker]["rd"][
                "last_reported_interim_revision_date"
              ]
            : `${mm}/${dd}/${yyyy}`;
        const dpParams = {
          dp: `${gridDataRowObj[ticker]["rd"][columnId]}|${date}`, //"16151916582|09/02/2020",
          cut: "STD",
          ticker: ticker,
          growthType: this.analyticsGrowthType.includes(columnId)
            ? "Analytics"
            : "YoY%",
          shouldLog: true,
          revision: "",
          period: period,
          is_universalsliid: true,
          extras: `${gridDataRowObj[ticker]["rd"][columnId]}|${period}`, //"16151916582|CY-2020"
        };
        if (this.sourceVaActuals.includes(columnId)) {
          dpParams["source"] = "va actuals";
        } else {
          dpParams["source"] = "consensus";
        }
        if (dpParams.growthType === "YoY%") {
          dpParams["historical_focus"] = "VA Actuals";
        }
        if (this.currency !== "Base") {
          dpParams["currency"] = this.currency;
        }
        if (this.tabType === TAB_BE_MAPPING.revision) {
          dpParams["is_comparative_rev"] = true;
        }
        this.store.dispatch(new SetDpParams(dpParams));
      }
      this.selectedCell = `${ticker}_${columnId}_${parentId || ""}`;
    } else {
      //there is no data
      this.selectedCell = "";
      this.store.dispatch(new DeleteDpParams());
    }
  }

  handleRowClick(rowId) {
    this.selectedCell = "";
    this.selectedRow = rowId;
  }

  editTickers() {
    this.tickersModal = this.modalService.create({
      nzTitle: "Edit Tickers",
      nzContent: ComparativeTickerModalComponent,
      nzMaskClosable: false,
      nzComponentParams: {
        addRowTableData: this.tickers, //this.addRowTableData,
        suggestedPeers: {
          watchername: "Suggested Peers",
          company_info: this.suggestedPeers,
        },
        recentlyVisitedCompanies: {
          company_info: this.recentlyVisitedCompanies
            ? [...this.recentlyVisitedCompanies]
            : [],
          watchername: "Recently viewed (up to 30)",
        },
        industryData: this.industryMenuData ? [...this.industryMenuData] : [],
        watchlistData: this.watchlistData ? [...this.watchlistData] : [],
        watchlistName: this.headerTitle,
        marketGeoData: this.marketGeoData
          ? { ...this.marketGeoData }
          : undefined,
        maxHeight: "340px",
        mpt: 1, //this.mpt,
        type: "edit",
        maxTickers: this.tickerLimit,
      },
      nzWrapClassName: "comps-modal-container vertical-center-modal",
      // nzWrapClassName: "watchlist-modal-container search-and-add-modal-container",
      nzFooter: [
        {
          label: "Cancel",
          type: "default",
          onClick: (): void => {
            this.tickersModal.destroy();
          },
        },
        {
          label: "Update",
          type: "primary",
          class: "update-btn",
          onClick: (data): void => {
            this.updateTickers(data);
          },
          disabled: (data) => {
            return (
              data["watchlistError"] !== "" ||
              data["modalData"].length > this.tickerLimit ||
              data["modalData"].length === 0
            );
          },
        },
      ],
    });
  }

  saveWatchlist(watchistError, modalData, watchlistName) {
    const tickerList = modalData.map((item) => {
      return item.ticker;
    });
    if (
      watchistError === "" &&
      watchlistName &&
      watchlistName.length > 0 &&
      tickerList.length > 0
    ) {
      const jsonData = {
        watchername: watchlistName,
        tickerlist: tickerList,
      };
      // this.isLoadingSaveWatchlist = true;
      let watchlistId = "";
      this.watchlistDataService.saveWatchlist(jsonData).subscribe(
        (response) => {
          if (response.status === "success") {
            watchlistId = response.watchlistid.toString();
            this.addWatchlistStore(watchlistId, watchlistName);
            this.initiateWatchlistFetch.emit();
          }
          this.snackbarInfo.message = `${watchlistName} saved as a new watchlist`;
          this.snackbarInfo.type = "info";
          this.showSnackBarToastMessage(this.snackbarInfo);
        },
        (error) => {
          // this.isLoadingSaveWatchlist = false;
          console.error(error);
        },
      );
    }
  }

  addWatchlistStore(watchlistId, watchlistName) {
    const payload = {
      respData: {
        watchlistId: Number(watchlistId),
        label: watchlistName,
      },
      key: this.storeDataKey,
    };
    this.store.dispatch(new AddWatchlistData(payload));
  }

  updateTickers(data) {
    const { modalData, watchlistName, watchlistError } = data;
    this.tickersModal.destroy();

    // FOR SAVING WATCHLIST
    if (data.saveWatchlist) {
      this.saveWatchlist(watchlistError, modalData, watchlistName);
    }
    const tickerId = [];
    const companyId = [];
    for (const item of modalData) {
      tickerId.push(item.ticker);
      companyId.push(item.company_id || item.cid);
    }
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const tickerToUpdate = {
        Ticker: {
          cids: companyId,
        },
      };
      const settingsPayload = updateCustomTableSettingsForTickers(
        this.compId,
        this.tabType,
        tickerToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.tickers = modalData;
            const tickerstate = { tickers: modalData };
            this.updateRevSupState.emit(tickerstate);

            this.createAndFetchCompTableData();

            this.fetchAndUpdateStdLineItems(
              modalData,
              true,
              this.currency,
              undefined,
            );
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.tickers = modalData;
      const tickerstate = { tickers: modalData };
      this.updateRevSupState.emit(tickerstate);
      this.createAndFetchCompTableData();
      this.updateUnsavedDataStatus.emit();
      this.fetchAndUpdateStdLineItems(
        modalData,
        true,
        this.currency,
        undefined,
      );
    }
  }

  onSearchTickerSelection(tickerData) {
    const { value } = tickerData;
    let checIfTickerExist = false;
    for (const item of this.tickers) {
      if (item.ticker === value.ticker) {
        checIfTickerExist = true;
        this.snackbarMessage = "This ticker is already present.";
        this.snackBarRef = this.snackBar.openFromTemplate(this.infoTemplate, {
          panelClass: "info",
          duration: 5000,
          verticalPosition: "top",
        });
      }
    }
    if (!checIfTickerExist && this.tickers.length <= this.tickerLimit) {
      this.updateSearchedTicker(tickerData);
    }
  }

  updateSearchedTicker(selectedTicker) {
    const tickerObj = {
      full_name: selectedTicker.value.name || selectedTicker.value.full_name,
      name: selectedTicker.value.name || selectedTicker.value.full_name,
      ticker: selectedTicker.value.ticker,
      company_id: selectedTicker.value.cid,
    };
    const allTickers = this.tickers.concat(tickerObj);
    const isUserPageType = this.checkIfUserPageType();
    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const tickerToUpdate = {
        Ticker: {
          cids: allTickers.map(
            (item) => item.company_id || item.cid || item.companyid,
          ),
        },
      };
      const settingsPayload = updateCustomTableSettingsForTickers(
        this.compId,
        this.tabType,
        tickerToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.tickers = allTickers;
            const tickerstate = { tickers: allTickers };
            this.updateRevSupState.emit(tickerstate);
            this.createAndFetchCompTableData();
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.tickers = allTickers;
      const tickerstate = { tickers: allTickers };
      this.updateRevSupState.emit(tickerstate);
      this.createAndFetchCompTableData();
      this.updateUnsavedDataStatus.emit();
    }
  }

  /**
   * Executes on selection of currency
   * It stores currency
   * @param {object} item - selected currency
   */
  handleCurrencyChange(item) {
    if (!item) {
      return;
    }

    const isUserPageType = this.checkIfUserPageType();

    if (isUserPageType) {
      this.isUserSettingUpdateInProgress = true;
      const currencyToUpdate = {
        Currency: {
          currency_iso: item,
        },
      };
      const settingsPayload = updateCustomTableSettings(
        this.compId,
        this.tabType,
        currencyToUpdate,
      );
      this.dataService
        .updateCustomComps(settingsPayload)
        .subscribe((response) => {
          if (response.status === "success") {
            this.currencyMessageSubscriber = this.compsDataService
              .getCurrencyMessage(item)
              .subscribe((res) => {
                if (res["status"] === "success") {
                  this.currency = item;
                  this.magnitudeMessage = res["magnitude_message"];
                  const currencyState = {
                    currency: item,
                    magnitudeMessage: res["magnitude_message"],
                  };
                  this.updateRevSupState.emit(currencyState);

                  this.createAndFetchCompTableData();
                }
              });
          }
          this.isUserSettingUpdateInProgress = false;
        });
    } else {
      this.currencyMessageSubscriber = this.compsDataService
        .getCurrencyMessage(item)
        .subscribe((res) => {
          if (res["status"] === "success") {
            this.currency = item;
            this.magnitudeMessage = res["magnitude_message"];
            const currencyState = {
              currency: item,
              magnitudeMessage: res["magnitude_message"],
            };
            this.updateRevSupState.emit(currencyState);

            this.createAndFetchCompTableData();
          }
        });
      this.updateUnsavedDataStatus.emit();
    }
  }
}
